import comp from "./NoGradeCalculationMethodSelectedWarning.js";
export default comp;
